import React, {PropTypes as T} from 'react';
import Modal, {ModalHeader, ModalContent, ModalFooter} from '../../common/modal';
import Button from '../../common/button';
import TU from '../../common/tu';
import withDevice from '../../common/withDeviceHOC';
import SadTicketIcon from '../../common/icons/icon_sad_ticket';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';
import Cookies from 'js-cookie';
import BasketActions from '../../../actions/basket';

export class SeatmapSeatsNoLongerAvailableErrorModal extends React.Component {
  static propTypes = {
    eventId: T.string,
    translations: T.object,
    onClose: T.func,
    isMobile: T.bool
  };

  static defaultProps = { onClose: Function.prototype };
  state = { isOpen: true };

  closeModal = () => {
    this.setState({ isOpen: false });
    setTimeout(this.props.onClose, 300);
  };

  goToBestAvailable = () => {
    Cookies.set(`EDP_TYPE_${this.props.eventId}`, 'CLASSIC');
    BasketActions.goToBestAvailable(this.props.eventId);
  };

  render () {
    const trans = this.props.translations;
    return (
      <Modal dataComponent="seats-not-available-error-modal" isOpen={this.state.isOpen} >
        <ModalHeader isError>
          <div className="modal__header__icon__wrapper">
            <ModalCautionIcon className="modal__header__icon" />
          </div>
          <div className="modal__header_title">{trans.SEATS_NOT_AVAILABLE_HEADER}</div>
        </ModalHeader>
        <ModalContent>
          <SadTicketIcon className="modal__sad_ticket_icon" />
          <TU text={trans.SEATS_NOT_AVAILABLE_MESSAGE} />
        </ModalContent>
        <ModalFooter>
          <Button
            data-component="best-available-button"
            primary
            onClick={this.goToBestAvailable}
            flex={this.props.isMobile}
            outlined>{trans.FIND_BEST_AVAILABLE_BUTTON}</Button>
          <Button
            data-component="change-selection-button"
            primary
            onClick={this.closeModal}
            flex={this.props.isMobile}>{trans.CHANGE_SELECTION_BUTTON}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withDevice(SeatmapSeatsNoLongerAvailableErrorModal);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/seats_no_longer_available_error.js